module.exports = __webpack_public_path__ + "img/product_103.e499008.svg";